import React from "react";
import classes from './Settings.module.scss'



const Settings = () => {
  return (
    <div className={classes.chat}>
      Settings
    </div>
  );
}

export default Settings;